import card_deposit from './card_deposit';
import cashapp_deposit from './cashapp_deposit';
import cashapp_p2p_rent from './cashapp_p2p_rent';
import cashapp_merchant_deposit from './cashapp_merchant_deposit';
import applepay_merchant_deposit from './applepay_merchant_deposit';
import googlepay_merchant_deposit from './googlepay_merchant_deposit';
import paypal_merchant_deposit from './paypal_merchant_deposit';
import cashapp_cashout from './cashapp_cashout';
import crypto from './crypto';
import bitcoin_deposit from './crypto';
import chime_deposit from './chime_deposit';
import chime_cashout from './chime_cashout';
import zelle_deposit from './zelle_deposit';

export default {
    card_deposit,
    cashapp_deposit,
    cashapp_p2p_rent,
    cashapp_merchant_deposit,
    applepay_merchant_deposit,
    googlepay_merchant_deposit, 
    paypal_merchant_deposit,
    cashapp_cashout,
    crypto,
    bitcoin_deposit,
    chime_deposit,
    chime_cashout,
    zelle_deposit
}